import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withKeys as _withKeys, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6d613a81")

_pushScopeId("data-v-6d613a81")
const _hoisted_1 = { class: "online" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "head" }, "自助客服", -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createVNode("i", { class: "el-icon-chat-dot-round" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_avatar = _resolveComponent("el-avatar")
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_image = _resolveComponent("el-image")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_popover = _resolveComponent("el-popover")
  const _component_el_affix = _resolveComponent("el-affix")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_el_affix, {
      position: "bottom",
      offset: 30
    }, {
      default: _withId(() => [
        _createVNode(_component_el_popover, {
          placement: "top-start",
          width: 400,
          trigger: "click"
        }, {
          reference: _withId(() => [
            _createVNode(_component_el_button, {
              circle: "",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.visible = true))
            }, {
              default: _withId(() => [
                _createVNode("i", null, [
                  _createVNode(_component_el_image, {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.visible = true)),
                    src: require('@/assets/img/online.png')
                  }, null, 8, ["src"])
                ])
              ]),
              _: 1
            })
          ]),
          default: _withId(() => [
            _hoisted_2,
            _createVNode(_component_el_scrollbar, {
              class: "content",
              height: "220px",
              "max-height": "220px",
              ref: "scroll"
            }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dialog, (item, index) => {
                  return (_openBlock(), _createBlock("div", {
                    class: ["block", item.type],
                    key: index
                  }, [
                    (item.type === 'to')
                      ? (_openBlock(), _createBlock("div", _hoisted_3, [
                          _createTextVNode(_toDisplayString(item.text) + " ", 1),
                          _createVNode(_component_el_avatar, { src: "https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png" })
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_4, [
                          _createVNode(_component_el_avatar, { src: "https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png" }),
                          _createTextVNode(" " + _toDisplayString(item.text), 1)
                        ]))
                  ], 2))
                }), 128))
              ]),
              _: 1
            }, 512),
            _createVNode("div", null, [
              _createVNode(_component_el_input, {
                size: "small",
                modelValue: _ctx.context,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.context = $event)),
                onKeyup: _withKeys(_ctx.consult, ["enter"])
              }, {
                append: _withId(() => [
                  _createVNode("div", {
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.consult && _ctx.consult(...args)))
                  }, [
                    _hoisted_5
                  ])
                ]),
                _: 1
              }, 8, ["modelValue", "onKeyup"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
})